(function () {
  'use strict';

  if (window.HanogramNativeUpsellLoaded) return;
  window.HanogramNativeUpsellLoaded = true;

  var widgetSelector = '[data-hanogram-native-upsell]';

  function updateCard(card) {
    var checkbox = card.querySelector('[data-upsell-checkbox]');
    card.classList.toggle('is-selected', Boolean(checkbox && checkbox.checked));
  }

  function updateVariant(select) {
    var card = select.closest('[data-upsell-card]');
    var option = select.options[select.selectedIndex];
    if (!card || !option) return;

    var price = card.querySelector('[data-upsell-price]');
    var comparePrice = card.querySelector('[data-upsell-compare-price]');
    var image = card.querySelector('.hanogram-native-upsell__image');

    if (price) price.textContent = option.dataset.price || '';
    if (comparePrice) {
      comparePrice.textContent = option.dataset.comparePrice || '';
      comparePrice.hidden = !option.dataset.comparePrice;
    }
    if (image && option.dataset.image) {
      image.src = option.dataset.image;
      image.removeAttribute('srcset');
    }
  }

  function formItem(form) {
    var formData = new FormData(form);
    var item = {
      id: Number(formData.get('id')),
      quantity: Math.max(1, Number(formData.get('quantity')) || 1)
    };
    var properties = {};

    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && value !== '') properties[match[1]] = value;
    });

    if (Object.keys(properties).length) item.properties = properties;
    if (formData.get('selling_plan')) item.selling_plan = Number(formData.get('selling_plan'));
    return item;
  }

  function selectedUpsells(widget) {
    return Array.prototype.map.call(
      widget.querySelectorAll('[data-upsell-checkbox]:checked'),
      function (checkbox) {
        var card = checkbox.closest('[data-upsell-card]');
        var select = card && card.querySelector('[data-upsell-variant]');
        return select ? { id: Number(select.value), quantity: 1 } : null;
      }
    ).filter(Boolean);
  }

  function showError(widget, message) {
    var error = widget.querySelector('[data-upsell-error]');
    if (!error) return;
    error.textContent = message || widget.dataset.errorMessage;
    error.hidden = false;
  }

  document.addEventListener('change', function (event) {
    var checkbox = event.target.closest('[data-upsell-checkbox]');
    if (checkbox) updateCard(checkbox.closest('[data-upsell-card]'));

    var select = event.target.closest('[data-upsell-variant]');
    if (select) updateVariant(select);
  });

  document.addEventListener('click', function (event) {
    var card = event.target.closest('[data-upsell-card]');
    if (!card || !card.closest(widgetSelector)) return;
    if (event.target.closest('input, label, select, option, a, button')) return;

    var checkbox = card.querySelector('[data-upsell-checkbox]');
    if (!checkbox) return;
    checkbox.checked = !checkbox.checked;
    updateCard(card);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.tt-product-single-info .btn-addtocart.addtocart-js');
    if (!button || button.classList.contains('disable')) return;

    var widget = document.querySelector(widgetSelector);
    var form = button.closest('form');
    if (!widget || !form) return;

    var accessories = selectedUpsells(widget);
    if (!accessories.length) return;

    var mainItem = formItem(form);
    if (!mainItem.id) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var error = widget.querySelector('[data-upsell-error]');
    if (error) error.hidden = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: [mainItem].concat(accessories) })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message);
          return data;
        });
      })
      .then(function (data) {
        var items = data.items || [];

        if (window.addToCartHandler && typeof window.addToCartHandler.addItem === 'function') {
          items.forEach(function (item) {
            window.addToCartHandler.addItem(item);
          });
        }

        var primaryItem = items.filter(function (item) {
          return Number(item.variant_id) === Number(mainItem.id);
        })[0] || items[0];

        if (primaryItem && window.addedModal && typeof window.addedModal.initSingleItem === 'function') {
          window.addedModal.initSingleItem(primaryItem);
        }

        if (window.Shopify && typeof window.Shopify.getCart === 'function') {
          window.Shopify.getCart();
        } else {
          window.location.assign('/cart');
        }
      })
      .catch(function (errorObject) {
        showError(widget, errorObject.message);
      })
      .then(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  }, true);
})();
